module.exports = __webpack_public_path__ + "./docs/img/logo.5e09da3c8edaa9fee814329c1a5f96b6.svg";